import 'reflect-metadata';
import dxConfig  from 'devextreme/core/config';
import { licenseKey } from './devextreme-license';
dxConfig({ licenseKey });

import { globalAjaxLoaderStore } from '@app/Stores/GlobalAjaxLoaderStore';

if (window.unsupportedMode) throw new Error('Your Browser is not supported!');
import './scss/App.scss';

import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';

import { configure } from "mobx";
configure({ enforceActions: "never" });

import { devInfoStore } from '@app/Stores/DevInfoStore';
import { NotificationHandler } from './Components/ToastNotification';
import { appStore } from '@app/AppStore';
import App from './App';

type IWindowWithErrors = {
    __pendingErrors?: ErrorEvent[];
};

import * as OfflinePluginRuntime from '@lcdp/offline-plugin/runtime';
OfflinePluginRuntime.install({
    onInstalled: function onInstalled() {
        console.log('OfflinePluginRuntime.onInstalled');
    },
    onUpdateReady: function onUpdateReady() {
        console.log('OfflinePluginRuntime.onUpdateReady');
    },
    onUpdating: function onUpdating() {
        console.log('OfflinePluginRuntime.onUpdating');
    },
    onUpdated: function onUpdated() {
        console.log('OfflinePluginRuntime.onUpdated');
    }
    // onUpdateReady: () => OfflinePluginRuntime.applyUpdate(),
    // onUpdated: () => window.swUpdate = true,
});

const keydownHandler = (event: KeyboardEvent) => {
    appStore.isShiftKey = event.shiftKey;
    appStore.isCtrlKey = event.ctrlKey || (appStore.isMacOS && event.metaKey); // event.metaKey - On Macintosh keyboards, this is the ⌘ Command key
    if (event.keyCode === 112 || event.keyCode === 113 || event.keyCode === 114 || event.keyCode === 115) {
        event.preventDefault();
        return false;
    }

    return true;
};

const keyupHandler = (event: KeyboardEvent) => {
    appStore.isShiftKey = event.shiftKey;
    appStore.isCtrlKey = event.ctrlKey || (appStore.isMacOS && event.metaKey);
    return true;
};

let devicePixelRatio: number = 0;

const resizeHandler = () => {

    if (!devicePixelRatio || devicePixelRatio !== window.devicePixelRatio) {
        devicePixelRatio = window.devicePixelRatio;

        const scrollDiv = document.createElement('div');
        scrollDiv.style.width = '100px';
        scrollDiv.style.height = '100px';
        scrollDiv.style.overflowY = 'scroll';
        scrollDiv.style.visibility = 'hidden';
        document.body.appendChild(scrollDiv);

        let scrollBarWidth = (scrollDiv.offsetWidth - scrollDiv.clientWidth);

        document.body.removeChild(scrollDiv);
        document.body.style.setProperty('--scrollbar-width', scrollBarWidth + 'px');
    }
};

document.addEventListener('keydown', keydownHandler, true);
document.addEventListener('keyup', keyupHandler, true);
window.addEventListener('resize', resizeHandler);

const pendingErrors = (window as IWindowWithErrors).__pendingErrors;
delete (window as IWindowWithErrors).__pendingErrors;
if (pendingErrors) {
    for (let i = 0; i < pendingErrors.length; i++) {
        NotificationHandler.showConsoleError(pendingErrors[i]);
    }
}

window.addEventListener('error', function(event){
    const loaderMessage = this.document.getElementById('react-app-loader-message');
    if (loaderMessage && !NotificationHandler.suppressError(event.message)){
        loaderMessage.innerText = 'Loading Error\n' + event.message;
    }
    NotificationHandler.showConsoleError(event);
});

window.addEventListener('message', e => {
    if (e.data && e.data.type === 'adal-error'){
        if (!devInfoStore.isProduction){
            NotificationHandler.showError(e.data.errorDescription as string, e.data.error as string);
        } else {            
            NotificationHandler.showConsoleError({
                error: e.data.error as string,
                message: e.data.errorDescription as string,
            });
        }
    }
}, false);

if (devInfoStore.isDevelopment) {
    const privateError = console.error;
    console.error = function (message: string) {
        window.setTimeout(() => {
            NotificationHandler.showError(message.toString());
        }, 0);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        privateError.apply(console, arguments as any);
    };
}

const rootEl = document.getElementById('react-app') as HTMLElement;

const renderCallback = () => {
    const loader = document.getElementById('react-app-loader');
    const message = document.getElementById('react-app-loader-message');
    const notification = document.getElementById('react-notification-bar');
    const notificationMessage = document.getElementById('react-notification-bar-message');
    if (loader && message) {
        globalAjaxLoaderStore.appLoaderElement = loader;
        globalAjaxLoaderStore.appLoaderMessageElement = message;
        loader.addEventListener(
            'transitionend',
            () => {
                if (loader.classList.contains('hide')) {
                    loader.classList.add('invisible');
                }
            },
            true
        );
    }
    if (notification) {
        appStore.notificationBar = notification;
        appStore.notificationBarMessage = notificationMessage;
    }
    resizeHandler();
};

ReactDOMClient.createRoot(rootEl).render(<App callback={renderCallback} />);
